import { SIZE_GROUPS } from '../utils/productSizes';

/**
 * Chooses which size selectors the product page will show. Before this existed
 * the page guessed from the product name, so a set of two mugs asked the
 * customer for a men's and a women's t-shirt size.
 */
export const SizePicker = ({ value = [], onChange }) => {
  const toggle = (key) => {
    onChange(value.includes(key) ? value.filter(k => k !== key) : [...value, key]);
  };

  return (
    <div style={{ margin: '6px 0 14px' }}>
      <div style={{ display: 'flex', gap: '18px', flexWrap: 'wrap' }}>
        {SIZE_GROUPS.map(({ key, label }) => (
          <label
            key={key}
            style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0, cursor: 'pointer' }}
          >
            <input
              type="checkbox"
              checked={value.includes(key)}
              onChange={() => toggle(key)}
              style={{ width: 'auto', margin: 0 }}
            />
            {label}
          </label>
        ))}
      </div>
      <small style={{ color: '#666' }}>
        {value.length === 0
          ? 'Няма да се пита за размер – за чаши, картички, пъзели, керамика и комплекти без дрехи.'
          : value.length === 1
            ? 'Ще се пита за един размер.'
            : `Ще се питат ${value.length} размера – по един за всяка дреха в комплекта.`}
      </small>
    </div>
  );
};
